/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AclAccessRequest } from '../../models/acl-access-request';

export interface GetAccessData$Params {
  arid?: number;
  orid?: number;
}

export function getAccessData(http: HttpClient, rootUrl: string, params?: GetAccessData$Params, context?: HttpContext): Observable<StrictHttpResponse<AclAccessRequest>> {
  const rb = new RequestBuilder(rootUrl, getAccessData.PATH, 'get');
  if (params) {
    rb.query('arid', params.arid, {});
    rb.query('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AclAccessRequest>;
    })
  );
}

getAccessData.PATH = '/api/AclRole/getAccessData';
